import React from 'react';
import styled, { css } from 'styled-components';

import useUI from 'hooks/use-ui';
import { useCommerceComponents } from 'theme/provider/commerce-components/context';
import CoreMenuHeader from './core-menu-header';
import StoreFrontHeader from './store-front-header';

export default function Header(props): JSX.Element {
  const { components } = useCommerceComponents();
  const { isStoreFront, isKiosk } = useUI();

  const ResolvedHeader = isStoreFront || isKiosk ? components.StoreFrontHeader({ fallback: StoreFrontHeader }) : null;
  const ResolvedNavigation = components.StoreFrontNavigation({ fallback: CoreMenuHeader });

  return (
    <Container isKiosk={isKiosk}>
      {(isStoreFront || isKiosk) && ResolvedHeader && <ResolvedHeader />}
      <ResolvedNavigation {...props} />
    </Container>
  );
}

const Container = styled.header`
  width: 100%;
  ${({ isKiosk }) =>
    isKiosk &&
    css`
      position: sticky;
      z-index: 20;
      top: 0;
    `}
`;
